import HeaderLeft from "../../../../components/Header/HeaderLeft"

export default function DrugHeader() {
  
  return (
<>

    <HeaderLeft
        
      headerleft = {'Right Drug - Right Dose'}

    />
      
   

</>
   )
}